






export default {
  name: 'sideview-button'
}



// WEBPACK FOOTER //
// ./src/components/sideview-button.vue